import { ButtonHTMLAttributes, ForwardedRef, forwardRef } from 'react';

import styles from './Button.module.scss';

export type ButtonProps = {
  variant?:
    | 'primary'
    | 'primary-dark'
    | 'primary-destructive'
    | 'secondary'
    | 'secondary-gray'
    | 'secondary-dark'
    | 'secondary-gray-destructive'
    | 'secondary-transparent'
    | 'plain'
    | 'borderless';
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
} & ButtonHTMLAttributes<HTMLButtonElement>;

function ForwardRefButton(
  { className, variant, size = 'md', ...rest }: ButtonProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  const variantClassName = variant ? ` ${styles[variant]}` : '';
  const extraClassNames = className ? ` ${className}` : '';
  const classNames = `${styles.button} ${variantClassName} ${styles[size]} ${extraClassNames}`;
  return <button className={classNames} ref={ref} {...rest} />;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(ForwardRefButton);
